import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import MainFooter from '../../components/MainFooter'
import MainHeaderBar from '../../components/MainHeaderBar'

const DashboardAuthLayout = props => {
  const { children, showFooter, title } = props

  return (
    <>
      <MainHeaderBar title={title} />
      <div style={{ padding: '20px' }}>
        {children}
      </div>
      {showFooter && <MainFooter />}
    </>
  )
}

DashboardAuthLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
}

export default inject('commonStore')(observer(DashboardAuthLayout))
